import { render, staticRenderFns } from "./PlayPlaylistButton.vue?vue&type=template&id=def1a3c4"
import script from "./PlayPlaylistButton.vue?vue&type=script&lang=js"
export * from "./PlayPlaylistButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports